var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfxGeneratorSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#3474E0",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 12.6667H17C16.558 12.6667 16.1341 12.8423 15.8215 13.1549C15.509 13.4675 15.3334 13.8914 15.3334 14.3334V27.6667C15.3334 28.1088 15.509 28.5327 15.8215 28.8453C16.1341 29.1578 16.558 29.3334 17 29.3334H27C27.4421 29.3334 27.866 29.1578 28.1786 28.8453C28.4911 28.5327 28.6667 28.1088 28.6667 27.6667V17.6667M23.6667 12.6667L28.6667 17.6667M23.6667 12.6667L23.6667 17.6667H28.6667M22 26.0001V21.0001M19.5 23.5001H24.5",
    stroke: "#3474E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfxGeneratorSelected);
export default __webpack_public_path__ + "static/media/rfx_generator_selected.e4ecbbe972c98ea99fe622efb50e7fdf.svg";
export { ForwardRef as ReactComponent };